var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3584_72868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 10.384 0.32 8.832 0.96 7.344C1.6 5.856 2.448 4.576 3.504 3.504C4.56 2.432 5.84 1.584 7.344 0.96C8.848 0.336 10.4 0.016 12 0C13.632 0 15.192 0.32 16.68 0.96C18.168 1.6 19.44 2.448 20.496 3.504C21.552 4.56 22.4 5.84 23.04 7.344C23.68 8.848 24 10.4 24 12C24 13.632 23.68 15.184 23.04 16.656C22.4 18.128 21.552 19.408 20.496 20.496C19.44 21.584 18.16 22.44 16.656 23.064C15.152 23.688 13.6 24 12 24C10.4 24 8.848 23.688 7.344 23.064C5.84 22.44 4.56 21.584 3.504 20.496C2.448 19.408 1.6 18.128 0.96 16.656C0.32 15.184 0 13.632 0 12ZM6 12C6 13.664 6.584 15.08 7.752 16.248C8.92 17.416 10.336 18 12 18C13.664 18 15.08 17.416 16.248 16.248C17.416 15.08 18 13.664 18 12C18 10.336 17.416 8.928 16.248 7.776C15.08 6.624 13.664 6.032 12 6C10.336 5.968 8.92 6.56 7.752 7.776C6.584 8.992 6 10.4 6 12Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3584_72868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogBlank);
export default __webpack_public_path__ + "static/media/Log-Blank.5e39c23c2db1f55875d777dc6b7db5d2.svg";
export { ForwardRef as ReactComponent };